import { render, staticRenderFns } from "./deviceData.vue?vue&type=template&id=0ddcef8c&scoped=true&"
import script from "./deviceData.vue?vue&type=script&lang=js&"
export * from "./deviceData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddcef8c",
  null
  
)

export default component.exports